import * as React from "react"

export const VerifiedProfileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      fill="#1E56FF"
      d="M13.83 9.16 15 8l-1.17-1.16.634-1.52-1.52-.623V3.045h-1.64l-.624-1.51-1.52.624L8 1 6.84 2.16l-1.52-.624-.623 1.51H3.045v1.64l-1.51.634.624 1.52L1 8l1.16 1.16-.624 1.52 1.51.623v1.64h1.64l.634 1.521 1.52-.634L8 15l1.16-1.17 1.52.634.623-1.52h1.64v-1.64l1.521-.624-.634-1.52Z"
    />
    <path
      fill="#fff"
      d="M5.083 7.988h.869v.869h-.869zm3.476 0h.869v.869h-.869zm.869-.869h.869v.869h-.869zm.869-.869h.869v.869h-.869zM5.952 8.857h.869v.869h-.869zm1.738 0h.869v.869H7.69zm-.869.869h.869v.869h-.869z"
    />
  </svg>
)
